import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';

/**
 * Formato de rosto: uma escolha entre sete formatos.
 * Referência: não há escala clínica formal. Segue a análise facial por
 * proporções usada em visagismo e harmonização facial (relação entre largura e
 * altura do rosto e largura da testa, das maçãs e da mandíbula). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/face_shape.php.
 */
const faceShape = {
  key: 'face_shape',
  name: 'Formato de rosto',
  description: 'Oval, redondo, quadrado, alongado, triangular, coração ou diamante',
  details: 'Registra o formato do rosto pela proporção entre largura e altura e pela largura da testa, das maçãs e da mandíbula. Não é uma escala clínica formal, mas é a base da análise facial em visagismo e harmonização: orienta onde dar ou tirar volume e ajuda a explicar o plano ao paciente. Um clique marca o formato do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: FaceOutlinedIcon,
  accent: 'purple',
  options: [
    { value: 'oval', label: 'Oval', image: 'formato-rosto-1.png', help: 'Mais longo que largo, com testa um pouco mais larga que o queixo e contorno suave.' },
    { value: 'round', label: 'Redondo', image: 'formato-rosto-2.png', help: 'Largura e altura parecidas, maçãs cheias e mandíbula arredondada, sem ângulos marcados.' },
    { value: 'square', label: 'Quadrado', image: 'formato-rosto-3.png', help: 'Testa, maçãs e mandíbula com larguras parecidas e ângulo da mandíbula bem marcado.' },
    { value: 'oblong', label: 'Alongado (retangular)', image: 'formato-rosto-4.png', help: 'Bem mais longo que largo, com laterais quase paralelas da testa à mandíbula.' },
    { value: 'triangle', label: 'Triangular', caption: 'Mandíbula mais larga que a testa', image: 'formato-rosto-5.png', help: 'Testa estreita e mandíbula larga: o rosto se alarga de cima para baixo.' },
    { value: 'heart', label: 'Coração', caption: 'Testa larga, queixo fino', image: 'formato-rosto-6.png', help: 'Testa e maçãs largas, afinando até um queixo estreito, às vezes pontudo.' },
    { value: 'diamond', label: 'Diamante', caption: 'Maçãs largas', image: 'formato-rosto-7.png', help: 'As maçãs do rosto são a parte mais larga, com testa e queixo estreitos.' },
  ],
};

export default faceShape;
